import React from 'react';
import { IconProps } from '.';

const SvgGridView = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M2 11V2h9v9H2Zm1.5-7.5h6v6h-6v-6ZM13 11V2h9v9h-9Zm1.5-7.5h6v6h-6v-6ZM2 13v9h9v-9H2Zm7.5 1.5h-6v6h6v-6ZM13 22v-9h9v9h-9Zm1.5-7.5h6v6h-6v-6Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgGridView;
